var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 547,
    height: 102,
    viewBox: "0 0 547 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 33C67 14.7746 81.7746 0 100 0H446C464.225 0 479 14.7746 479 33V102H67V33Z",
    fill: "#B7B6B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M526.499 67C497.499 67 480.999 54 478.999 30.5L453.499 81L524.999 85.5C540.666 79.5 564.099 67 526.499 67Z",
    fill: "#ACB3B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2285 67.5C49.2285 67.5 65.0003 55 67.0002 31.5L93.2285 81.5L21.7285 86C6.06181 80 -17.3715 67.5 20.2285 67.5Z",
    fill: "#ACB3B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArch);
export default __webpack_public_path__ + "static/media/icon-arch.18dc7373f2982f51ccb3411ea9e4b5d5.svg";
export { ForwardRef as ReactComponent };